import gql from 'graphql-tag';

export const queryForRolesAndClaims = gql`
  query queryForRolesAndClaims(
    $limit: Int
    $page: Int
    $query: RoleSortOrQuery
    $sort: RoleSortOrQuery
  ) {
    queryForRolesAndClaims(
      limit: $limit
      page: $page
      query: $query
      sort: $sort
    ) {
      items {
        id
        name
        claims
      }
      totalRecords
    }
  }
`;
